import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";


import Banner_Container from "../../Banners/container";
import InventoryList from "./InventoryList";
import ReplaceCartModal from "../../PopUp/ReplaceCartPopUp";

import { useApiRequest } from "../Login/Hooks/useApiRequest";
import TodaySpecialComponent from "./TodaySpecial/component";
import Procced from "../../ProccedToPay/component";

import "./vmlist.css";
import BuyAgain from "./BuyAgain/Component";
import SearchBar from "./SearchBar/Component";
import VmInventoryHeader from "../../Header/component";

import PendingPickup from "../PendingPickup/component";
import WaitingLoder from "../../Loader/component";

import QRModal  from "../VmList/Qr";
import SortFilterDrawer from "./Filter";
import NoActiveMachine from "./NoActiveMachine";

const VmInventoryContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { makeApiRequest } = useApiRequest();

  const searchParams = new URLSearchParams(location.search);
  const machineId = searchParams.get("machineId");
  const uuid = searchParams.get("value");
 const showItems = searchParams.get("showItems");
 //const showItems = true
  const [vmInventoryWithCount, setVmInventoryWithCount] = useState([]);
  const [vmName,setVmName]=useState(null)
  const [uuid_vmId,setUuid_vmId]=useState(null)
  const [vmaddress,setVmaddress]=useState(null)
  const [todaySpecialvmInventoryWithCount, setTodaySpecialvmInventoryWithCount] = useState([]);
  const [preCart, setPreCart] = useState([]);
  const [preCartCombo, setPreCartCombo] = useState([]);
  const [replaceSlot, setReplaceSlot] = useState(null);
  const [replaceCard, setReplaceCard] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [searchTerms,setSearchTerms] = useState(null)
  const [vmInventory,setVmInventory]=useState([])
  const [activeOrders,setActiveOrders]=useState([])
  const [userDetails,setUserDetails]=useState(null)
  const [loader,setLoader]=useState(false)
  const comboFetchedRef = useRef(false);
  const [qrModelflag, setQrModelflag] = useState(false);
  const [filterflag,setFilterFlag]=useState(false)
  const [buyAgainList,setBuyAgainList]=useState([])
  const [buyAgainwithCount,setBuyAgainwithCount]=useState([])

   const [comboList,setComboList]=useState([])
  const [comboListwithCount,setComboListwithCount]=useState([])
const [showSearchfiled,setShowSearchfiled]=useState(false)
const [inventroyMsg,setInventroyMsg]=useState("Loading Data...")
const [loadingVmdata,setLoadingVmdata]=useState(false)

const [f_uuid,setUuid]=useState(null)
  const [tab, setTab] = useState("filters");

  /* ---------- STATES ---------- */
  const [categories, setCategories] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [sortValue, setSortValue] = useState("");
  const [priceRange, setPriceRange] = useState([0, 250]);
  const [trayLevel, setTrayLevel] = useState("all");
  const [filterData,setFilterData]=useState(null)
  const [machine_uuid_flag,setMachine_uuid_flag]=useState(false)

useEffect(() => {


  // ✅ Check if machineId is valid
const isMachineIdValid =
  machineId &&
  machineId.toString().toLowerCase() !== "null" &&
  machineId.toString().toLowerCase() !== "false";

const routeData = `machineId=${machineId}&value=${uuid}`;
const url = `/entryPointQr?route=${encodeURIComponent(routeData)}`;

    //console.log("isMachineIdValid",isMachineIdValid)
  if (isMachineIdValid) {
        //console.log("isMachineIdValid",isMachineIdValid)
    if(showItems){
    //fetchVmInventory(machineId);
    }
    else{
      navigate(url)
      ///entryPointQr?route=items&machineId=${machineId}&value=${uuid}

    }
  } else if (uuid) {
//console.log("isMachineIdValid",isMachineIdValid,uuid)
       if(showItems){
        //console.log("uuid---",uuid)
   fetchMachineByUUID(uuid);
    }
    else{
      navigate(url)
    }
   
  } else {
    //console.warn("❌ No valid machineId or uuid found");
  }
}, []);

localStorage.setItem("machineId",machineId)



useEffect(()=>{
//fetchVmInventory(uuid_vmId)
 fetchBuyAgain()
},[uuid_vmId])

  
const fetchMachineByUUID = (uuid) => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
setUuid(uuid)
  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/machinebyuuid/${uuid}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
    },
    handleSuccess: (res) => {
      const machineId = res?.data?.data?.machineId;
      if (machineId) {
        //fetchVmInventory(machineId);
        setUuid_vmId(machineId)
        navigate(`/items?machineId=${machineId}&value=${uuid}&showItems=true`)
      } else {

        toast.error("Machine not found for this device", {
          position: "top-right",
          autoClose: 1500,
        });
      }
    },
    handleError: (err) => {
     
      const code = err.response.data.status.code
             
  console.log("uuid",uuid)
  setMachine_uuid_flag(true)
  

if(code=="UNAUTHORIZED"){
      navigate(`/login?value=${uuid}`)
}

 /*      toast.error("Failed to fetch machine by UUID", {
        position: "top-right",
        autoClose: 1500,
      }); */
    },
  });
};
  // -----------------------
  // Utility: Apply cart counts to inventory
  // -----------------------
  const applyCartCounts = (inventory, cartItems) => {
    //console.log("inventory",inventory)
    return inventory.map((invItem) => {
      const matchedCartItem = cartItems?.find(
        (cartItem) => parseInt(cartItem.slotId) === parseInt(invItem.slot_id)
      );
      return {
        ...invItem,
        mycount: matchedCartItem ? matchedCartItem.count : invItem.mycount || 0,
      };
    });
  };

  // -----------------------
  // Initialize vmInventory with count
  // -----------------------
  useEffect(() => {
    const inventoryWithCount = vmInventory.map((item) => ({
      ...item,
      mycount: item.mycount || 0,
    }));
    setVmInventoryWithCount(inventoryWithCount);
        const buyAgainWithCount = buyAgainList.map((item) => ({
      ...item,
      mycount: item.mycount || 0,
    }));
   
    setBuyAgainwithCount(buyAgainWithCount)

        const comboWithCount = comboList.map((item) => ({
      ...item,
      mycount: item.mycount || 0,
    }));
   
    setComboListwithCount(comboWithCount)



  }, [vmInventory,buyAgainList,comboList]);



  useEffect(()=>{

        const filterDataWithCount = filterData&&filterData[0]&&filterData.map((item) => ({
      ...item,
      mycount: item.mycount || 0,
    }));

        setFilterData(filterDataWithCount)

  },[])
  // -----------------------
  // Fetch combo inventory (once)
  // -----------------------

const handleComboResponse=(res)=>{
  //console.log("combo----",res.data.data)
  setComboList(res.data.data)


}

  const fetchComboInventory = () => {
    if (comboFetchedRef.current) return;

    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/combo`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: (res) => {

        handleComboResponse(res)
      },

      handleError: (err) => {},
    });

    comboFetchedRef.current = true;
  };

  // -----------------------
  // Fetch pre-cart data
  // -----------------------
  const fetchPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: handleResponsePreCart,
      handleError: handleErrorPreCart,
    });
  };


  const fetchActiveOrders = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/active`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
      accept: "application/json, text/plain, */*",
    },
    handleSuccess: (res) => {
      
      // Do something with active orders, e.g.,
      setActiveOrders(res?.data?.data || []);
    },
    handleError: (err) => {
 
      toast.error("Unable to fetch active orders.", {
        position: "top-right",
        autoClose: 1500,
      });
    },
  });
};
useEffect(()=>{},[buyAgainwithCount])
  const handleResponsePreCart = (res) => {
   
    const cartItems = res?.data?.data?.items || [];
    const preMachineId = res?.headers?.["machineid"];
 const totalAmount = cartItems.reduce((sum, item) => sum + (item.amount * item.count), 0);


      setTotalAmount(totalAmount);

    setPreCart(cartItems);
    setPreCartCombo(res?.data?.data?.comboDetails || []);

    if (machineId === preMachineId) {
      setVmInventoryWithCount((currentInventory) =>
        applyCartCounts(currentInventory, cartItems)
      );
      setTodaySpecialvmInventoryWithCount((currentInventory) =>
        applyCartCounts(currentInventory, cartItems)
      );

setBuyAgainwithCount((currentInventory) => {


  const updatedInventory = applyCartCounts(currentInventory, cartItems);


  return updatedInventory;
});

setFilterData((currentInventory) => {

if(currentInventory){
  const updatedInventory = applyCartCounts(currentInventory, cartItems);


  return updatedInventory;
}
}); 

    }
  };

  const handleErrorPreCart = (error) => {
  
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("UserJWTAuth");
    
    } else {
     /*  toast.error(`${error.response?.data?.status?.code || "Error"}`, {
        position: "top-right",
        autoClose: 1000,
      }); */
    }
  };

  // -----------------------
  // Fetch Today's Special inventory
  // -----------------------
  const handleResponseVmInventorySpecial = (res) => {
    const items = res.data.data || [];
    const inventoryWithCount = items.map((item) => ({ ...item, mycount: 0 }));

    fetchPreCart();

    const updatedInventory =
      preCart.length > 0
        ? applyCartCounts(inventoryWithCount, preCart)
        : inventoryWithCount;

    setTodaySpecialvmInventoryWithCount(updatedInventory);
  };

  const handleErrorVmInventorySpecial = (err) => {
    toast.error(`${err.response?.data?.status?.message || "Error"}`, {
      position: "top-right",
      autoClose: 1500,
    });
  };

  const fetchVmInventoryTodaySpecial = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/special`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
      },
      handleSuccess: handleResponseVmInventorySpecial,
      handleError: handleErrorVmInventorySpecial,
    });
  };

  // -----------------------
  // Add/Remove item to cart
  // -----------------------
  const handleResponseAddIntoCart = (res, slot_id, operation) => {
   
    setLoader(false)
    localStorage.setItem("card_id", res.headers["cart-id"]);
    fetchPreCart()

    const cartItems = res?.data?.data?.items || [];
    const matched = cartItems.find(
      (item) => parseInt(item.slotId) === parseInt(slot_id)
    );

    setVmInventoryWithCount((prev) => {
      const updated = prev.map((p) => {
        if (p.slot_id !== slot_id) return p;
        if (operation === "add")
          return { ...p, mycount: matched ? matched.count : p.mycount + 1 };
        return { ...p, mycount: matched ? matched.count : Math.max(0, p.mycount - 1) };
      });


      



      // 🔹 Update total after inventory change


      return updated;
    });

    
    setTodaySpecialvmInventoryWithCount((prev) =>
      prev.map((p) => {
        if (p.slot_id !== slot_id) return p;
        if (operation === "add")
          return { ...p, mycount: matched ? matched.count : p.mycount + 1 };
        return { ...p, mycount: matched ? matched.count : Math.max(0, p.mycount - 1) };
      })
    );

       setBuyAgainwithCount((prev) => {
      const updated = prev.map((p) => {
        if (p.slot_id !== slot_id) return p;
        if (operation === "add")
          return { ...p, mycount: matched ? matched.count : p.mycount + 1 };
        return { ...p, mycount: matched ? matched.count : Math.max(0, p.mycount - 1) };
      });

      // 🔹 Update total after inventory change


      return updated;
    });



    setFilterData((prev) => {
      const updated = prev&&prev.map((p) => {
        if (p.slot_id !== slot_id) return p;
        if (operation === "add")
          return { ...p, mycount: matched ? matched.count : p.mycount + 1 };
        return { ...p, mycount: matched ? matched.count : Math.max(0, p.mycount - 1) };
      });


      



      // 🔹 Update total after inventory change


      return updated;
    });


  };


  const handleErrorAddIntoCart = (err) => {
     setLoader(false)
    if (
      err.response &&
      err.response.data.status.message ===
        "Cart contains items from another machine"
    ) {
      setReplaceCard(true);
    }
    toast.error(`${err.response?.data?.status?.message}`, {
      position: "top-right",
      autoClose: 1500,
    });
  };

  const handleCartOpertation = (e, index, slot_id, currentCount, operation) => {
    //console.log("currentCount",currentCount,operation)
     setLoader(true)
    e.stopPropagation();
    const token = localStorage.getItem("UserJWTAuth");
 

    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    if ((preCart?.length > 0) || (preCartCombo?.length > 0)) {
      setReplaceSlot({ slot_id, index });
    }

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${replaceCard}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slot_id), count: payloadCount }],
      handleSuccess: (res) => handleResponseAddIntoCart(res, slot_id, operation),
      handleError: handleErrorAddIntoCart,
    });
  };




const fetchBuyAgain = (e) => {
  e?.stopPropagation?.();

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  // 🔒 Ensure user is logged in
  if (!token) {
    //toast.error("Please login to view your previous purchases");
  
  }

  // 🚀 Make API request using same pattern as handleCartOperation
  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/previously-purchased`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    handleSuccess: handleResponseBuyAgain,
    handleError: handleErrorBuyAgain,
  });
};

const handleResponseBuyAgain=(res)=>{
 
setBuyAgainList(res.data.data)
}

const handleErrorBuyAgain=()=>{
  
}






  const replaceMyCardFun = (e) => {
    setReplaceCard(false);
    if (replaceSlot)
      handleCartOpertation(e, replaceSlot.index, replaceSlot.slot_id, 0, "add");
  };

  // -----------------------
  // Redirect if not authenticated
  // -----------------------
  useEffect(() => {
    const token = localStorage.getItem("UserJWTAuth");
   
  }, [navigate]);

  // -----------------------
  // Fetch combo, today special & pre-cart when inventory is ready
  // -----------------------

  useEffect(() => {
  if (machineId) {
    fetchItems(); // no filters
  }
}, [machineId]);
  useEffect(() => {
    if (vmInventory.length > 0) {
     // setLoader(true)
      fetchComboInventory();
      fetchVmInventoryTodaySpecial();
    
      //fetchPreCart();
      fetchActiveOrders()
     // fetchCategories()
     

    }
  }, [vmInventory]);

  // -----------------------

      const filteredproducts = vmInventoryWithCount&&vmInventoryWithCount.filter((product) =>
      product.mv_name.toLowerCase().includes(searchTerms?.toLowerCase())
      );


  const ShowQRFun = (e) =>{
    
    setQrModelflag(true)



  }

  
    const CloseQrFun = (e) =>{
    
    setQrModelflag(false)



  }
if(qrModelflag){
  return <QRModal ShowQRFun={ShowQRFun} qrModelflag={qrModelflag}  CloseQrFun={CloseQrFun} preCart={preCart} fetchMachineByUUID={fetchMachineByUUID} />
}
  
const CloseFilter=()=>{
setFilterFlag(false)
}





  const fetchCategories = () => {
    setLoader(true)
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/consumerbe/api/v2/item/category",
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        setCategories(res?.data?.data || []);
        setLoader(false)
      },
      handleError: (err) => {
        setLoader(false)
        //console.error(err)


      },

    });
  };

const fetchItems = ({ applyFilter = false } = {}) => {
  setLoader(true);

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  if (!machineId) return;

  const params = new URLSearchParams();

  // Always required
  params.append("exclude_inactive", "false");

  // 🔹 Apply filters only when needed
  if (applyFilter) {
    params.append("price_min", priceRange[0]);
    params.append("price_max", priceRange[1]);

    const { sort_by, sort_order } = getSortParams(sortValue);
    if (sort_by) params.append("sort_by", sort_by);
    if (sort_order) params.append("sort_order", sort_order);

    if (trayLevel && trayLevel !== "all") {
      params.append("tray_level", trayLevel);
    }

    if (selectedCategoryIds.length > 0) {
      params.append("category_id_arr", selectedCategoryIds.join("|"));
    }
  }

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/items?${params.toString()}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    handleSuccess: (res) => {
      setVmName(res?.headers?.name);
      setVmaddress(res?.headers?.address);


      const items = (res?.data?.data || []).map(item => ({
        ...item,
        mycount: 0,
      }));
   
      // 🔹 If filter applied → store separately
      if (applyFilter) {
        setFilterData(items);
      } else {
        setVmInventory(items);
      }
      setLoadingVmdata(true)
      fetchPreCart(); // sync cart counts
      setLoader(false);
      
    },
    handleError: (err) => {
      setLoader(false);
    /*   toast.error("Failed to load inventory"); */
    },
  });
};




const handleCategoryToggle = (id) => {
  setSelectedCategoryIds((prev) => {
    const updated = prev.includes(id)
      ? prev.filter((item) => item !== id)
      : [...prev, id];

    //console.log("Selected Category IDs:", updated); // ✅ correct
    return updated;
  });
};


 /*  const handleReset = () => {
    setFilterData(null)
    setSelectedCategoryIds([]);
    setSortValue("");
    setPriceRange([0, 250]);
    setTrayLevel("all");
    CloseFilter()
  }; */
const handleReset = () => {
  setFilterData(null);
  setSelectedCategoryIds([]);
  setSortValue("");
  setPriceRange([0, 250]);
  setTrayLevel("all");

  fetchItems(); // reload normal inventory
  CloseFilter();
};

    const getSortParams = (value) => {
      switch (value) {
        case "price-low":
          return { sort_by: "price", sort_order: "asc" };
        case "price-high":
          return { sort_by: "price", sort_order: "desc" };
        case "stack-top":
          return { sort_by: "slot", sort_order: "asc" };
        case "stack-bottom":
          return { sort_by: "slot", sort_order: "desc" };
        default:
          return {};
      }
    };


            const ApplyFillter = () => {
              setLoader(true)
  fetchItems({ applyFilter: true });
  CloseFilter();
};

const buildItemsUrl = () => {
  const outletId = machineId;

  const { sort_by, sort_order } = getSortParams(sortValue);

  const params = new URLSearchParams();

  params.append("exclude_inactive", "false");
  params.append("price_min", String(priceRange[0]));
  params.append("price_max", String(priceRange[1]));

  if (sort_by) params.append("sort_by", sort_by);
  if (sort_order) params.append("sort_order", sort_order);

  if (trayLevel && trayLevel !== "all") {
    params.append("tray_level", trayLevel);
  }

  // ✅ Pipe-separated category IDs
  if (Array.isArray(selectedCategoryIds) && selectedCategoryIds.length > 0) {
    params.append(
      "category_id_arr",
      selectedCategoryIds.join("|")
    );
  }

  const url = `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${outletId}/items?${params.toString()}`;

  //console.log("Final URL:", decodeURIComponent(url)); // readable log
  return url;
};

const gotohome=()=>{

  navigate("/")
}
if(machine_uuid_flag){
 return <NoActiveMachine uuid={f_uuid}  gotohome={gotohome}/>
}


  return (
    <>

    <SortFilterDrawer open={filterflag} onClose={CloseFilter} 
    ApplyFillter={ApplyFillter} 
    categories={categories}
     selectedCategoryIds={selectedCategoryIds} 
    sortValue={sortValue} 
    priceRange={priceRange}
    setPriceRange={setPriceRange}
    trayLevel={trayLevel}
    setTrayLevel={setTrayLevel}
    setSortValue={setSortValue}
    tab={tab}
  
  
    setTab={setTab}
    handleReset={handleReset}

    handleCategoryToggle={handleCategoryToggle}
    /> 
    {loader&&<WaitingLoder/>}

   
          <VmInventoryHeader
              title={vmName}
              subtitle={vmaddress}
              route="/"
              ShowQRFun={ShowQRFun}
               preCart= {preCart}
              




              
            />
      
<Box    sx={{display:{xs:"block",md:"",sm:"block"},
        //backgroundImage: ' linear-gradient(to bottom, #ffffff, #f4fcff)',
        background: "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
        minHeight: '100vh',
        padding: "12px",

        color: '#fff', // Set text color to white
    }}
>
      {replaceCard && (
        <ReplaceCartModal
          replaceMyCardFun={replaceMyCardFun}
          setReplaceCard={setReplaceCard}
        />
      )}


      { <div style={{paddingTop:"50px"}}><Banner_Container vmid={machineId || 0} /> </div>} 
     
     

   
      {!searchTerms&& <BuyAgain buyAgainList={buyAgainwithCount} onIncrement={handleCartOpertation} onDecrement={handleCartOpertation}/>}
         

      {!searchTerms&&<TodaySpecialComponent
        onIncrement={handleCartOpertation}
        onDecrement={handleCartOpertation}
        data={todaySpecialvmInventoryWithCount}
      />}
<div style={{    paddingBottom:
      activeOrders && activeOrders[0] && preCart && preCart[0]
        ? "135px"
        : preCart && preCart[0]
        ? "50px"
        : activeOrders && activeOrders[0] && activeOrders.length > 1
        ? "115px"
        : activeOrders && activeOrders[0]
        ? "80px"
        : "0px", // fallback padding if none are true
   }}>

     {showSearchfiled&&<SearchBar setSearchTerms={setSearchTerms} searchTerms={searchTerms} setShowSearchfiled={setShowSearchfiled}/>}
      <InventoryList
        items={filterData?filterData:searchTerms?filteredproducts:vmInventoryWithCount}
        
        onIncrement={handleCartOpertation}
        onDecrement={handleCartOpertation}
         setFilterFlag={setFilterFlag}
         setSearchTerms={setSearchTerms}
         searchTerms={searchTerms}
         showSearchfiled={showSearchfiled}
         setShowSearchfiled={setShowSearchfiled}
         fetchCategories={fetchCategories}
        inventroyMsg={inventroyMsg}
        loadingVmdata={loadingVmdata}
      /> 
      </div>
      </Box>
       {activeOrders&&activeOrders[0]&&<PendingPickup  preCart={preCart&&preCart[0]&&preCart}  activeOrders={activeOrders} page={"vmItems"}/>}
       
      {preCart&&preCart[0]&&<Procced preCart={preCart&&preCart[0]&&preCart}  totalAmount={totalAmount}  page={"vmItems"} />}
    </>
  );
};

export default VmInventoryContainer;
